import { render, staticRenderFns } from "./CategoryStateFruit.vue?vue&type=template&id=c5115176"
import script from "./CategoryStateFruit.vue?vue&type=script&lang=js"
export * from "./CategoryStateFruit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports